import { line, area, curveBumpX } from 'd3';


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const Marks = ({
	data,
	xScale,
	yScale,
	xValue,
	yValue,
	// tooltipFormat,
	// circleRadius,
	innerHeight
}) => (
	<g >
		<path
			className="session-timeline-marks"
			d={line()
				.x(d => xScale(xValue(d)))
				.y(d => yScale(yValue(d)))
				.curve(curveBumpX)(data)}
			fill="none"
			stroke="rgb(89,91,243)"

		/>

		<path
			className="session-timeline-area"
			d={area()
				.x(d => xScale(xValue(d)))
				.y0(() => innerHeight)
				.y1(d => yScale(yValue(d)))
				.curve(curveBumpX)(data)}
		/>
		{
			//data.map(d => (
			//  <circle cx={xScale(xValue(d))} cy={yScale(yValue(d))} r={circleRadius}>
			//    <title>{tooltipFormat(xValue(d))}</title>
			//  </circle>
			//))
		}
	</g>
);
